import type { Dayjs } from 'dayjs';
import type { ActivityDTO } from 'src/types/dto/activity.dto';
import type { ActivityPreferredDateDto } from 'src/types/dto/activity-preferred-date.dto';

import dayjs from 'dayjs';

import { getDefaultAvailabilityWindow } from 'src/components/shuffle/get-default-availability-ranges';

import type { ActivityDatePreference } from './activity-date-preference.types';
import { ActivityPreferredDateType } from 'src/types/dto/activity-preferred-date.dto';

export const getInclusiveDurationDays = (start: Dayjs, end: Dayjs) =>
  end.startOf('day').diff(start.startOf('day'), 'day') + 1;

export const formatActivityPreferredDate = (date: Dayjs) => date.format('YYYY-MM-DD');

function mapPreferredDateDtoToPreference(
  dto: ActivityPreferredDateDto
): ActivityDatePreference {
  return {
    id: dto.id,
    type: dto.type,
    start: dayjs(dto.startDate).startOf('day'),
    end: dayjs(dto.endDate).startOf('day'),
  };
}

export function deriveActivityDatePreferences(activity: ActivityDTO): ActivityDatePreference[] {
  const windowRange = getDefaultAvailabilityWindow(activity.startDate, activity.dueDate);
  const preferences: ActivityDatePreference[] = [
    {
      id: 'completion-window',
      type: 'completionWindow',
      start: windowRange.from,
      end: windowRange.to,
      isSystem: true,
    },
  ];

  const persistedPreferences = (activity.preferredDates ?? []).map(mapPreferredDateDtoToPreference);

  const schemeBlackoutPreferences: ActivityDatePreference[] = (activity.blackoutDates ?? [])
    .filter((blackout) => blackout.startDate || blackout.endDate)
    .map((blackout, index) => ({
      id: `scheme-blackout-${blackout.id ?? index}`,
      type: ActivityPreferredDateType.EXCLUDED,
      start: dayjs(blackout.startDate ?? blackout.endDate).startOf('day'),
      end: dayjs(blackout.endDate ?? blackout.startDate).startOf('day'),
      isSystem: true,
    }));

  return [...preferences, ...schemeBlackoutPreferences, ...persistedPreferences];
}
